import React from "react";

import {
  Alert,
  AlertTitle,
  AlertDescription,
} from "@/components/molecules/Alert";
import ExperiencesIcon from "@/icons/__generated__/Experiences/Experiences20";
import { useBookListingContext } from "~/components/listings/book-listing/BookListingContext";

const BookListingSecondaryAlert = () => {
  const { secondaryAlertConfig, hideSecondaryAlert } = useBookListingContext();

  return (
    <Alert
      className="tw-mb-20 sm:tw-mb-12"
      isVisible={secondaryAlertConfig.isVisible}
      onDismiss={hideSecondaryAlert}
      onUnmount={hideSecondaryAlert}
      {...(secondaryAlertConfig?.alertProps ?? {})}
    >
      <ExperiencesIcon />
      <div className="tw-pl-8">
        <AlertTitle>{secondaryAlertConfig.message}</AlertTitle>
        <AlertDescription>{secondaryAlertConfig.description}</AlertDescription>
      </div>
    </Alert>
  );
};

export { BookListingSecondaryAlert };
